import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "value", "onClick", "onChange", "onValueChange", "disabled", "checked", "inputRef"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * @file withCheckedWrapper
 * @author Yu Zong(liuxuanzy@qq.com)
 */
import { useCombineCallback } from '@tencent/glue-react-use';
import React from 'react';
import { INPUT_COMMON_ATTRS } from '../const/input';
export function withCheckedWrapper(type, Component) {
  return function (props) {
    var children = props.children,
        value = props.value,
        onClick = props.onClick,
        onChange = props.onChange,
        onValueChange = props.onValueChange,
        disabled = props.disabled,
        checked = props.checked,
        inputRef = props.inputRef,
        extra = _objectWithoutProperties(props, _excluded);

    var input = {};
    INPUT_COMMON_ATTRS.forEach(function (key) {
      if (key in extra) {
        Object.assign(input, _defineProperty({}, key, extra[key]));
        delete extra[key];
      }
    });
    var onCheckChange = useCombineCallback(function (e) {
      return onValueChange === null || onValueChange === void 0 ? void 0 : onValueChange(e.target.checked);
    }, onChange);
    var onLabelClick = useCombineCallback(function (e) {
      var target = e.target;

      if (target.nodeName === 'INPUT') {
        e.stopPropagation();
        e.nativeEvent.stopImmediatePropagation();
      }
    }, onClick);
    return React.createElement(Component, _objectSpread(_objectSpread({}, extra), {}, {
      disabled: disabled,
      checked: checked,
      onClick: onLabelClick
    }), React.createElement("input", _objectSpread({
      type: type,
      checked: checked,
      disabled: disabled,
      value: value,
      onChange: onCheckChange,
      ref: inputRef,
      style: {
        pointerEvents: 'none',
        zIndex: -1,
        opacity: 0,
        visibility: 'hidden',
        position: 'absolute',
        width: '0',
        height: '0',
        left: '-9999px'
      }
    }, input)), children);
  };
}